/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guestlist_Point_1Inputs */

const en_guestlist_point_1 = /** @type {(inputs: Guestlist_Point_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Market weeks live: rooms, capacity, waitlist, check-in`)
};

/**
* | output |
* | --- |
* | "Market weeks live: rooms, capacity, waitlist, check-in" |
*
* @param {Guestlist_Point_1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const guestlist_point_1 = /** @type {((inputs?: Guestlist_Point_1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guestlist_Point_1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_guestlist_point_1(inputs)
});